/* eslint-disable no-console */
import React, { useEffect, useState, useCallback } from 'react'
import { Switch, Route } from 'react-router'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { gmtsWebApi } from '@services'

import {
  RootState
} from 'AppTypes'

import StoreDetails from '@features/store-details'
import TopPage from '@features/top'
import SearchStore from '@features/search-store'
import Vote2022 from '@features/vote-2022'
import { RightSidebar } from './partials/right_sidebar'
import Header from './partials/header'
import PageNotFoundLayout from './404'

import './html/assets/css/style.css'
import Footer from './partials/footer'

type Props = {}
const dataTitleField: any = null

const Main: React.FC<Props> = () => {
  const [getWebNotification, setGetWebNotification] = useState()
  const [dataTitle, setdataTitle] = useState(dataTitleField)
  const fetchNotification = async () => {
    const res = await gmtsWebApi.getWebNotification()
    if (res && res.data) {
      setGetWebNotification(res.data)
    }
  }
  const getDataTopTitle = useCallback((data: any, key: string) => {
    if (!data) return false
    const indexTopTitle = data.findIndex((x: any) => checkTitle(x.targets, key))
    if (typeof indexTopTitle === 'number' && indexTopTitle !== -1) return data[indexTopTitle]
    return false
  }, [])

  useEffect(() => {
    fetchNotification()
  }, [])

  useEffect(() => {
    setdataTitle(getDataTopTitle(getWebNotification, 'TopHeader'))
  }, [getWebNotification, getDataTopTitle])

  const checkTitle = (data : any, keyFilter: string) => {
    const key = data.findIndex((x: any) => x === keyFilter)
    if (key !== -1) return true
    return false
  }

  return (
    <>

      <div className="wrapper">
        <header>
          <Header webNotification={getWebNotification} getDataTopTitle={getDataTopTitle} />
        </header>
        <main className="container-fluid">
          <div className="main-content">
            <div className="main-title">
              {
                dataTitle && dataTitle.content && `◆ ${dataTitle.content}`
              }
              {
                dataTitle && dataTitle.notificationLinks && dataTitle.notificationLinks.length > 0
                  ? <Link to={{ pathname: dataTitle.notificationLinks[0].url }} target="_blank">{dataTitle.notificationLinks[0].text}</Link>
                  : ''
              }
            </div>
            <Switch>
              <Route path="/vote2022" component={Vote2022} />
              <Route path="/shop/:id" component={StoreDetails} />
              <Route path="/search_result" component={SearchStore} />
              <Route exact path="/" component={TopPage} />
              <Route component={PageNotFoundLayout} />
            </Switch>
          </div>
          <div className="right-widget">
            <RightSidebar />
          </div>
        </main>
        <Footer />
      </div>

    </>
  )
}

export default connect((state: RootState) => ({
  appState: state.app,
  routerState: state.router
}))(Main)
